/*
  sim-pdp-pickers.js  (2026-10-13, Claude Design "PDP Mobile Buy Area": Size chips + Color chips combined)

  Phones only (<750px), product template with the buy card (html.sim-pk-ready is set by
  snippets/sim-pdp-split-open.liquid).

  Every option group (Size, Color, ...) becomes ONE always-visible row of chips that scrolls sideways when
  there are more than fit. The row's legend reads "Size: Small, chest 23-28 in" with the Size-chart link on
  the right; Color chips get a small color dot. The radios, labels, availability ("Sold out") text and the
  Size-chart link are the theme's originals, so Shopify's variant logic is untouched.

  product-info.js swaps the whole <variant-selects> after every variant change, so a MutationObserver on
  <product-info> rebuilds the chips (idempotent).
*/
(function () {
  if (window.__simPickers) return;
  window.__simPickers = true;
  var mq = window.matchMedia('(max-width: 749px)');
  var root = document.documentElement;
  var mo = null;
  var queued = false;

  // Common product colors -> dot color. Unknown names simply get no dot.
  var COLORS = {
    black: '#1B221F', white: '#FFFFFF', grey: '#8A8F98', gray: '#8A8F98', charcoal: '#3C3F44', silver: '#C0C4CC',
    sand: '#D8C6A5', camel: '#B98A55', brown: '#7A5230', mocha: '#5B4033', espresso: '#3B2A22', tan: '#C9A27A',
    beige: '#D9C7A6', cream: '#F1E8D2', ivory: '#F5EEDC', khaki: '#B8A87A', red: '#C0392B', burgundy: '#6E1F2B',
    pink: '#E88CA5', blush: '#EBC1BC', rose: '#C7667A', orange: '#E58A3A', yellow: '#E8C547', gold: '#C9A24A',
    green: '#3F7D4E', myrtle: '#3F5B4B', olive: '#6B6F3A', teal: '#2E7F83', blue: '#2F5FA7', navy: '#1B2A4A',
    purple: '#6B4A9B', lavender: '#B7A6D6', ice: '#DCEBF2', camo: '#6B7048', leopard: '#C79A55', pearl: '#E7E1D6',
    pewter: '#7C8088', natural: '#D8CBB0', alloy: '#9AA0A6', slate: '#5E6672', aqua: '#6CC3C8', mint: '#A8D5BA', coral: '#EE7B6B', plum: '#6A3A5E', stone: '#B9B2A5'
  };

  function textOf(el) { return (el && el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function labelOf(f) { var lg = f.querySelector('legend'); return lg && lg.firstChild ? textOf(lg.firstChild) : 'Option'; }

  function dotColor(name) {
    var n = String(name || '').toLowerCase().trim();
    if (COLORS[n]) return COLORS[n];
    var words = n.split(/[^a-z]+/).filter(Boolean);
    for (var i = words.length - 1; i >= 0; i--) if (COLORS[words[i]]) return COLORS[words[i]];
    return '';
  }

  function build() {
    queued = false;
    var card = document.querySelector('product-info .sim-pdp-card');
    var on = mq.matches && !!card;
    root.classList.toggle('sim-pk-ready', on);
    var vs = document.querySelector('product-info variant-selects');
    if (!on || !vs) return;
    if (mo) mo.disconnect();
    try {
      [].slice.call(vs.querySelectorAll('fieldset')).forEach(function (f) {
        var radios = f.querySelectorAll('input[type="radio"]');
        if (!radios.length) return;
        f.classList.add('sim-pk-fs');
        var isColor = /colou?r/i.test(labelOf(f));
        f.classList.toggle('sim-pk-color', isColor);
        f.classList.toggle('sim-pk-sizefs', /^sizes?$/i.test(labelOf(f)));

        var wrap = f.querySelector('.sim-pk-chips');
        if (!wrap) {
          var kids = [].slice.call(f.children).filter(function (n) { return n.tagName === 'INPUT' || n.tagName === 'LABEL'; });
          wrap = document.createElement('div');
          wrap.className = 'sim-pk-chips';
          f.insertBefore(wrap, kids[0] || null);
          kids.forEach(function (n) { wrap.appendChild(n); });
        }

        // Long names like "X-Large (23"-25" from collar to base of tail)": short bold name + small descriptor line
        [].slice.call(wrap.querySelectorAll('label')).forEach(function (lab) {
          if (lab.querySelector('small') || lab.__pkSplit) return;
          var tn = null;
          for (var i = 0; i < lab.childNodes.length; i++) { if (lab.childNodes[i].nodeType === 3 && lab.childNodes[i].textContent.trim()) { tn = lab.childNodes[i]; break; } }
          if (!tn) return;
          var m = /^\s*(.+?)\s*\((.+)\)\s*$/.exec(tn.textContent);
          if (!m || m[1].length > 18) return;
          lab.__pkSplit = true;
          tn.textContent = m[1];
          var sm = document.createElement('small');
          sm.textContent = m[2];
          tn.parentNode.insertBefore(sm, tn.nextSibling);
          lab.setAttribute('data-pk-name', m[1]);
        });

        // color dots: only when EVERY color in the group is recognized (a half-dotted row looks patchy)
        if (isColor && !wrap.querySelector('.sim-pk-dot')) {
          var labs = [].slice.call(wrap.querySelectorAll('label'));
          var cols = labs.map(function (lab) {
            var inp = wrap.querySelector('input[id="' + lab.htmlFor + '"]');
            return dotColor(inp ? inp.value : textOf(lab));
          });
          if (labs.length && cols.every(Boolean)) {
            labs.forEach(function (lab, i) {
              var d = document.createElement('i');
              d.className = 'sim-pk-dot';
              d.style.background = cols[i];
              lab.insertBefore(d, lab.firstChild);
            });
          }
        }

        // "Size: Small, chest 23-28 in" (our own span; the theme's " · value" span is hidden by CSS)
        var chk = wrap.querySelector('input:checked');
        var lg = f.querySelector('legend');
        if (lg) {
          var cur = lg.querySelector('.sim-pk-cur');
          if (!cur) {
            cur = document.createElement('span');
            cur.className = 'sim-pk-cur';
            var after = lg.querySelector('.sim-lg-val');
            lg.insertBefore(cur, after || null);
          }
          var lab2 = chk && wrap.querySelector('label[for="' + chk.id + '"]');
          var val = chk ? ((lab2 && lab2.getAttribute('data-pk-name')) || chk.value) : '';
          var sm = lab2 && lab2.querySelector('small');
          var sub = sm ? textOf(sm) : '';
          var t = val ? ': ' + val + (sub ? ', ' + sub : '') : '';
          if (cur.textContent !== t) cur.textContent = t;
        }

        // keep the selected chip in view, then show a soft fade when more chips are off-screen
        var lab3 = chk && wrap.querySelector('label[for="' + chk.id + '"]');
        if (lab3 && wrap.scrollWidth > wrap.clientWidth + 2 && !wrap.__touched) {
          var want = Math.max(0, lab3.offsetLeft - 16);
          if (Math.abs(wrap.scrollLeft - want) > 4) wrap.scrollLeft = want;
        }
        if (!wrap.__wired) {
          wrap.__wired = true;
          wrap.addEventListener('touchstart', function () { wrap.__touched = true; }, { passive: true });
          wrap.addEventListener('scroll', function () { fade(wrap); }, { passive: true });
        }
        fade(wrap);
      });
    } finally {
      watch();
    }
  }

  function fade(wrap) {
    var more = wrap.scrollWidth - wrap.clientWidth - wrap.scrollLeft > 4;
    wrap.classList.toggle('sim-pk-chips--more', more);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    // setTimeout, not requestAnimationFrame: rAF is paused while the page is not being painted
    // (background/hidden tab), which would leave the chips un-rebuilt after a variant swap.
    setTimeout(build, 30);
  }

  function watch() {
    var pi = document.querySelector('product-info');
    if (!pi || !window.MutationObserver) return;
    // Rebuild right away (a MutationObserver callback runs before the next paint), so the freshly inserted
    // plain option rows are turned into chips before they are ever drawn.
    if (!mo) mo = new MutationObserver(function () { build(); });
    mo.observe(pi, { childList: true, subtree: true });
  }

  setInterval(function () {
    var vs = document.querySelector('product-info variant-selects');
    if (vs && mq.matches && document.querySelector('product-info .sim-pdp-card') && !vs.querySelector('.sim-pk-chips') && vs.querySelector('fieldset input[type="radio"]')) schedule();
  }, 1000);
  if (mq.addEventListener) mq.addEventListener('change', build);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();
